import { Box, FormErrorMessage, Input } from "@chakra-ui/react";
import { IMCFormInvoiceItems } from "./interface";
import CardFormAlt from "../CardFormAlt";
import { InheritModalContentProps } from "../FullWidthModal/interface";
import { ModalContent } from "../FullWidthModal";
import ResponsiveFormControl from "../ResponsiveFormControl";
import { Controller } from "react-hook-form";
import InputCartTable from "../InputCartTable";
import BoxInput from "../BoxInput";
import NumberFormat from "../NumberFormat";

const MCModalFormInvoiceItems: React.FC<
  InheritModalContentProps<IMCFormInvoiceItems>
> = (props) => {
  return (
    <ModalContent
      {...props}
      defaultValues={{
        additionalCost: 0,
      }}
    >
      {({ control, watch, errors, trigger, register }) => {
        const watchItems = watch("items");
        const watchAdditionalCost = watch("additionalCost");

        const subTotal =
          watchItems?.reduce((total, item) => {
            return total + item.price * item.qty;
          }, 0) || 0;

        const total = subTotal - (watchAdditionalCost || 0);

        return (
          <form autoComplete="off">
            <Controller
              name="items"
              control={control}
              rules={{
                validate: (data) => {
                  if (!data || data.length <= 0) return false;

                  for (let i = 0; i < data.length; i++) {
                    if (!data[i].itemName || !data[i].price || !data[i].qty) {
                      return false;
                    }
                  }

                  return true;
                },
              }}
              render={({ field: { onChange, value } }) => (
                <InputCartTable
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    trigger();
                  }}
                />
              )}
            />
            {errors.hasOwnProperty("items") && (
              <Box color="red" mt={2}>
                Item is required!
              </Box>
            )}

            <CardFormAlt mt={10} title="Billing Detail">
              <ResponsiveFormControl label="Subtotal">
                <BoxInput justifyContent="flex-end">
                  <NumberFormat prefix="$ " value={subTotal} />
                </BoxInput>
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Eddition Costa"
                isInvalid={errors.hasOwnProperty("additionalCost")}
                messageComponents={
                  <FormErrorMessage>
                    Eddition Costa is not valid
                  </FormErrorMessage>
                }
              >
                <Input
                  textAlign="right"
                  {...register("additionalCost", {
                    validate: (value) => {
                      return value >= 0;
                    },
                    valueAsNumber: true,
                  })}
                />
              </ResponsiveFormControl>
              <ResponsiveFormControl label="NTA">
                <BoxInput justifyContent="flex-end">
                  <NumberFormat prefix="$ " value={total} />
                </BoxInput>
              </ResponsiveFormControl>
            </CardFormAlt>
          </form>
        );
      }}
    </ModalContent>
  );
};

export default MCModalFormInvoiceItems;
